import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Shared selector hook for tab inventory actions (Rooms, Packs, Experiences)
 * Single source of truth for the { setForm, setModifiedInventory } pair.
 * Re-exported under tab-specific names for call-site clarity.
 *
 * @returns Common inventory tab actions
 */
export const useTabInventoryActions = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      setForm: state.setForm,
      setModifiedInventory: state.setModifiedInventory,
      addEditedRoomField: state.addEditedRoomField,
      setHasDeactivatedPricingRuleByEdit:
        state.setHasDeactivatedPricingRuleByEdit,
      setIsEditMode: state.setIsEditMode,
    }))
  );
};
